export default "__VITE_ASSET__CGTv5STB__"